import { toast } from "sonner";

/** Ce que l'élu doit vérifier sur une copie (produit ou collection), par
 * exemple une règle de subvention posée sur l'original qui ne la suit pas.
 * Le message reste affiché jusqu'à ce que l'élu le ferme. */
export const toastDuplicateWarnings = (warnings: string[]) => {
  if (warnings.length === 0) return;
  toast.warning("À vérifier sur la copie :", {
    description: warnings.join("\n"),
    duration: Infinity,
    closeButton: true,
  });
};
